module.exports = __webpack_public_path__ + "static/media/my-heroes-have-always-been-junkies.05f3adcc.jpg";